import * as React from "react";

const CustomEditIcon: React.FC = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19.2678 2.19675L17.8033 0.732292C16.827 -0.243997 15.2441 -0.244036 14.2678 0.732292L0.501463 14.4985L0.00587659 18.9589C-0.0604515 19.556 0.444158 20.0605 1.04119 19.9942L5.5015 19.4986L19.2678 5.73229C20.244 4.75596 20.244 3.17303 19.2678 2.19675ZM15.5492 7.68307L6.79685 16.4354V15.0782H4.92185V13.2032H3.56463L12.3169 4.45085L15.5492 7.68307ZM4.9276 18.3046L2.6231 18.5607L1.43931 17.3769L1.69537 15.0724L2.47088 14.2969H3.8281V16.1719H5.7031V17.5291L4.9276 18.3046ZM18.3838 4.84839L16.433 6.79921L13.2008 3.56698L15.1516 1.61616C15.6401 1.12768 16.4308 1.12761 16.9194 1.61616L18.3838 3.08061C18.8724 3.56913 18.8724 4.35979 18.3838 4.84839Z"
                fill="#474747"
            />
        </svg>
    );
};

export default React.memo(CustomEditIcon);
